// extracted by mini-css-extract-plugin
export var active = "_fj-7";
export var blink = "_fj-8";
export var dropDownSelector = "_fj-4";
export var dropDownWrapper = "_fj-3";
export var fakeCursor = "_fj-6";
export var fontSizeButton = "_fj-9";
export var formQuillEditor = "_fj-0";
export var pressed = "_fj-a";
export var qlBlank = "_fj-1";
export var textFormattingToolbar = "_fj-2";
export var textToolbarOption = "_fj-5";